import { useLocationServiceContext } from '@frontend/wam-location-service';
import { Dashboard } from '@frontend/wam-views';
import { Page } from '../components/page-layout/page';
import { createFileRoute } from '../utils/route-factory';

const DashboardPage = () => {
  const { currentLocation } = useLocationServiceContext();
  return (
    <Page
      title='Dashboard'
      loading={!currentLocation}
      breadcrumbs={[
        {
          label: 'Dashboard',
        },
      ]}
    >
      {currentLocation?.locationId && <Dashboard locationId={currentLocation.locationId} />}
    </Page>
  );
};

export const Route = createFileRoute({
  path: '/dashboard',
  component: DashboardPage,
  type: 'auth',
});
